<template>
  <v-app class="view">

    <v-navigation-drawer
        :width="drawer_width"
        absolute
        class="nav fix-menu"
        permanent
        touchless
    >

      <v-card :class="{primary:activeMenu==='users'}" :to="'/admin'" class="pa-2" outlined tile>
        User
      </v-card>
      <v-card :class="{primary:activeMenu==='data'}" :to="'/data'" class="pa-2" outlined tile>
        Data
      </v-card>
      <v-card :class="{primary:activeMenu==='admin_setting'}" :to="'/admin_setting'" class="pa-2" outlined tile>
        Setting
      </v-card>


    </v-navigation-drawer>
    <v-content>
      <v-container
          :style="{
                        paddingLeft:(12+drawer_width)+'px',
                     }"
          child-flex
          class="container"

          fluid>
        <form v-if="selectedObject" @submit.prevent="onSubmitObject">
          <v-card class="pa-8">
            <v-card-title>
              ตั้งค่าการอนุมัติ
            </v-card-title>
            <v-container>
              <v-row>
                <v-col>
                  <label>
                  ผู้อนุมัติยอดขั้นต่ำ 1
                  </label>
                </v-col>
                <v-col>
                  <v-text-field
                      v-model="selectedObject.approving_minimal_1"
                      class="dialog-input"
                      hide-details
                      label="username"
                      outlined
                      placeholder=""
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <label>
                    ผู้อนุมัติยอดขั้นต่ำ 2
                  </label>
                </v-col>
                <v-col>
                  <v-text-field
                      v-model="selectedObject.approving_minimal_2"
                      class="dialog-input"
                      hide-details
                      label="username"
                      outlined
                      placeholder=""
                  >
                  </v-text-field>
                </v-col>
              </v-row>            </v-container>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn :loading="objectLoading"
                     color="primary" type="submit">
                บันทึก
              </v-btn>
            </v-card-actions>
          </v-card>
        </form>
      </v-container>
    </v-content>


  </v-app>
</template>
<style lang="scss" scoped>


.view {
  font-size: 18px;
}

.nav {
  z-index: 1;
}

.container {
  position: relative;
  margin-top: 0px;
}

.pad-filter {
  padding: 16px 0 0 24px;
}

.search .v-input__control {
  /*height: 60px;*/
}

.theme--light .list-header-row {
  background: #FFFFFF;
}

.theme--dark .list-header-row {
  background: #000000;
}

</style>
<script lang="ts">

import {SimpleResponse} from '@/models/Model'
import {UserConst} from '@/models/User'
import {Component, Vue} from 'vue-property-decorator'
import LoadingDummy from '../components/LoadingDummy.vue'
import {DataArray} from '../models/Response'
import {User} from '../models/User'
import Helper from '../services/Helper.js'

@Component({
  components: {LoadingDummy}
})
export default class ViewAdminSetting extends Vue {

  drawer_ratio = 0.15
  drawer_width = 200

  activeMenu = 'setting'


  selectedObject = {
    approving_minimal_1: '',
    approving_minimal_2: '',
  }
  objectLoading = false

  async refreshObject() {
    const url = Helper.setting.setting.getListAPI + '?keys=' + Object.keys(this.selectedObject)

    try {
      this.objectLoading = true
      this.selectedObject = await Helper.get(url).then<{ data: DataArray }>(({data}) => data.setting)
    } catch (e) {
      alert(e)
    }
    this.objectLoading = false
  }

  async onSubmitObject() {
    const url = Helper.setting.setting.getListAPI

    try {
      this.objectLoading = true
      await Helper.post(url, {setting: this.selectedObject}).then<{ data: DataArray }>(({data}) => data.setting)
      this.$root.$emit('onSuccess', {message: 'บันทึกสำเร็จ'})
    } catch (e) {
      alert(e)
    }
    this.objectLoading = false


  }

  async mounted() {
    this.drawer_width = Math.max(80, Math.round(window.innerWidth * this.drawer_ratio))
    console.log('window.innerWidth', window.innerWidth)
    this.refreshObject().then(() => {
    })
  }
}
</script>
